export const FLIGHT_FAIL_TEST_ID = 'FLIGHT_FAIL_TEST_ID';
export const FLIGHT_FAIL_CHANGE_FLIGHT_TEST_ID =
  'FLIGHT_FAIL_CHANGE_FLIGHT_TEST_ID';
export const FLIGHT_FAIL_REDIRECT_TO_HOTEL_TEST_ID =
  'FLIGHT_FAIL_REDIRECT_TO_HOTEL_TEST_ID';
